export abstract class RemoteTranslations {};
export const TRANSLATIONS_MAP = {

  "accept": "Aceitar",
  "activate": "Ativar",
  "address_country": "País",
  "address_information": "Informações de endereço",
  "address_state": "Estado",
  "app_features_editarLimiteDeUsoCupom": "Habilitar edição de limite de uso do cupom",
  "app_features_habilitarCarteiraPicpay": "Habilitar Carteira PicPay",
  "app_features_habilitarCartaoEstrangeiro": "Habilitar cartão estrangeiro",
  "app_features_habilitarCupomNaSacola": "Habilitar cupom na sacola",
  "app_features_habilitarPixEstrangeiro": "Habilitar Pix estrangeiro",
  "app_features_habilitarTelaIdioma": "Habilitar tela de idioma",
  "app_features_habilitarTelaNotificacoes": "Habilitar tela de notificações",
  "app_features_login_apple": "Habilitar login com Apple",
  "app_features_login_facebook": "Habilitar Login com Facebook",
  "app_features_login_google": "Habilitar login com Google",
  "app_features_taxaParcelamentoDinamica": "Taxa de parcelamento dinâmica",
  "app_features_teatro": "Habilitar teatro",
  "atualizacao_necessaria": "Atualização necessária",
  "atualizar_app": "Abrir loja e atualizar o app",
  "available_tickets": "Ingressos disponíveis",
  "bad_gateway_error": "Falha ao se comunicar com o servidor. Tente novamente mais tarde.",
  "balance_transfer": "Saldo para repasse",
  "barra_estados_dropdown_label": "Estado",
  "batch_add": "Adicionar lote",
  "batch_amount_allowed": "Quantidade permitida por compra",
  "batch_created": "Lote criado com sucesso",
  "batch_description": "Descrição do lote",
  "batch_disable": "Desativar lote",
  "batch_edit": "Editar lote",
  "batch_edit_link": "Link do lote",
  "batch_enable": "Ativar lote",
  "batch_finished": "Encerrado",
  "batch_formLabels_purchaseLimit": "Quantidade permitida por compra",
  "batch_formLabels_value": "Valor",
  "batch_manager_page_title": "Lotes",
  "batch_name": "Nome do lote",
  "batch_tickets": "Ingressos",
  "batch_updated": "As informações do lote foram alteradas",
  "birth_date": "Data de nascimento",
  "button_next": "Próximo",
  "button_show_events": "Ver eventos",
  "button_show_sessions": "Ver sessões",
  "button_show_tickets": "Ver ingressos",
  "buy_with": "Comprar com",
  "cadastro_code_received": "Código recebido por e-mail",
  "cadastro_popup_finalizar": "Finalizar",
  "cadastro_termos_1": "Concordo com os ",
  "cadastro_termos_2": "termos",
  "cadastro_termos_3": " e as ",
  "cadastro_termos_4": "políticas.",
  "camera_code": "Digitar o código",
  "camera_search": "Procurando QR Code",
  "cancel": "Cancelar",
  "cancel_tickets": "Cancelar ingresso",
  "cancelar_ingresso_1": "Os ingressos podem ser cancelados até 7 dias após a compra, desde que a solicitação seja feita antes das 48 horas que antecedem o início do evento.",
  "cancelar_ingresso_2": "Se você estiver dentro do prazo, você poderá enviar o seu pedido de cancelamento para",
  "cannot_be_empty": "Campo obrigatório",
  "cardholders_name": "Nome do titular do cartão",
  "carteira_cancelar_compra": "Cancelar compra",
  "carteira_cancelar_compra_dialog_content": "O reembolso acontecerá de acordo com a forma de pagamento escolhida.",
  "carteira_cancelar_compra_dialog_title": "Confirmar cancelamento",
  "carteira_cancelar_transferencia": "Ingresso enviado",
  "carteira_codigo_expirado": "Código de confirmação expirado. Seu pedido será cancelado automaticamente.",
  "carteira_como_encontrar_codigo": "Como encontrar o código?",
  "carteira_compra_cancelada": "Pedido cancelado",
  "carteira_compra_cancelar_compra_tooltip": "Cancelar compra",
  "carteira_compra_cancelar_compra_tooltip_disabled": "A compra não pode ser cancelada",
  "carteira_compra_expirada": "Pedido expirado",
  "carteira_compra_gratuita": "Gratuito",
  "carteira_compra_nova": "Pedido realizado",
  "carteira_compra_pedido_estorno": "Reembolso solicitado",
  "carteira_compra_pendente": "Aguardando pagamento",
  "carteira_compra_pendente_3ds": "Confirmação pendente",
  "carteira_compra_pendente_picpay": "Aguardando aprovação no PicPay",
  "carteira_compra_reprovada": "Erro ao realizar pedido",
  "carteira_compra_validada": "Compra confirmada",
  "carteira_comprar_bebidas": "Comprar bebidas",
  "carteira_compras_anteriores": "COMPRAS ANTERIORES",
  "carteira_data_compra": "Data da compra",
  "carteira_data_evento": "Data do evento",
  "carteira_digite_codigo": "Digite o código",
  "carteira_evento_finalizado": "Evento finalizado",
  "carteira_forma_pagamento_cartao": "Cartão",
  "carteira_forma_pagamento_carteira_picpay": "Carteira PicPay",
  "carteira_forma_pagamento_google": "Google Pay",
  "carteira_forma_pagamento_none": "À vista",
  "carteira_forma_pagamento_paypal": "PayPal",
  "carteira_forma_pagamento_pix": "Pix",
  "carteira_forma_pagamento_wallet": "Apple Pay",
  "carteira_ingressos": "Ingressos",
  "carteira_ingressos_disponiveis": "Ingressos utilizados: {disponiveis}/{total}",
  "carteira_pedido": "Pedido",
  "carteira_products_empty": "Você ainda não comprou produtos...",
  "carteira_produtos_disponiveis": "Produtos utilizados: {disponiveis}/{total}",
  "carteira_produtos_restantes": "Restantes: {}",
  "carteira_recusar_transferencia": "Ingresso recebido",
  "carteira_resgate_produto_confirmation": "Confirmo que recebi o produto.",
  "carteira_resgate_produto_title": "Para resgatar o produto, arraste o botão de validação:",
  "carteira_tab_compras": "Compras",
  "carteira_tab_ingressos": "Ingressos",
  "carteira_tab_produtos": "Produtos",
  "carteira_tab_tickets": "Tickets",
  "carteira_tickets_anteriores": "Tickets anteriores",
  "carteira_ver_produtos": "Ver produtos",
  "carteira_ver_transferencias": "Transferências pendentes",
  "carteira_verificar_compra_descricao": "Confirme o código de 4 dígitos enviado para a fatura do seu cartão, no aplicativo do seu banco.",
  "carteira_verificar_compra_title": "@:common_codigo_verificacao da compra",
  "categoria_evento_ALTERNATIVO": "🎶 Alternativo",
  "categoria_evento_ANIVERSARIO": "🎉 Aniversário",
  "categoria_evento_BRASILIDADE": "🇧🇷 Brasilidade",
  "categoria_evento_DISCO": "🕺 Disco",
  "categoria_evento_ELETRONICO": "🔊 Eletrônico",
  "categoria_evento_FUNK": "🔥 Funk",
  "categoria_evento_HALLOWEEN": "🎃 Halloween",
  "categoria_evento_HOUSE": "🎧 House",
  "categoria_evento_OUTRO": "Outra",
  "categoria_evento_PALESTRA": "🎙️ Palestra",
  "categoria_evento_POOL_PARTY": "💦 Pool Party",
  "categoria_evento_POP": "🎤 Pop",
  "categoria_evento_PRIVATIVO": "🔒 Privativo",
  "categoria_evento_REVEILLON": "✨ Réveillon",
  "categoria_evento_SAMBA": "🥁 Samba",
  "categoria_evento_SERTANEJO": "🪗 Sertanejo",
  "categoria_evento_TEATRO": "🎭 Teatro",
  "categoria_evento_TRIBAL": "🪭 Tribal",
  "cellphone_number": "Telefone",
  "cellphone_number_page_dados": "Telefone",
  "cellphone_number_payment": "Telefone",
  "cellphone_number_ticket": "Celular",
  "check_out": "Finalizar",
  "check_out_paypal": "Finalizar com PayPal",
  "check_out_pix": "Finalizar com Pix",
  "checkin_batch": "Lote",
  "checkin_camera": "Iniciar câmera",
  "checkin_manager_page_title": "Check-in",
  "checkin_manual_checkin_confirmation_dialog": "Deseja realizar check-in em",
  "checkin_name": "Nome",
  "checkin_no": "Não",
  "checkin_number": "Check-ins realizados",
  "checkin_number_of": "de",
  "checkin_search": "Check-in por nome, e-mail ou CPF",
  "checkin_send_info": "Exportar participantes",
  "checkout_cancel_agreement_1": "Estou de acordo com as ",
  "checkout_cancel_agreement_2": "politicas",
  "checkout_cancel_agreement_3": " de cancelamento",
  "checkout_finished": "Compra realizada!",
  "checkout_finished_text": "Pedido realizado!",
  "checkout_info_address": "Complete as informações de endereço:",
  "checkout_info_address_saved": "(Elas ficarão salvas para as suas próximas compras)",
  "checkout_info_contact": "Complete as informações de contato:",
  "checkout_info_contact_saved": "(Elas ficarão salvas para as suas próximas compras)",
  "checkout_ticket_info_subtitle": "Complete as informações dos ingressos:",
  "checkout_validation_cancel_subtitle": "Você ainda poderá confirmar a compra até o fim do prazo determinado pela sua carteira.",
  "city": "Cidade",
  "city_page_dados": "Cidade",
  "code_expires_in": "Código expira em:",
  "common_accept": "Aceitar",
  "common_alterado_sucesso": {
    "female": "{} alterada com sucesso!",
    "male": "{} alterado com sucesso!",
    "other": "{} alterado com sucesso!"
  },
  "common_cancel": "@:cancel",
  "common_codigo_verificacao": "Código de verificação",
  "common_confirm": "@:confirm",
  "common_dg_crud_initial_text": "Carregando",
  "common_espetaculo": "Espetáculo",
  "common_evento": "Evento",
  "common_exportar": "Exportar",
  "common_idioma": "Idioma",
  "common_ilimitado": {
    "female": "Ilimitada",
    "male": "Ilimitado",
    "other": "Ilimitado"
  },
  "common_new": "Novo",
  "common_none": {
    "female": "Nenhuma",
    "male": "Nenhum",
    "other": "Nenhum"
  },
  "common_open_in_maps": "Abrir no Google Maps",
  "common_options": "Opções",
  "common_retry": "Tentar novamente",
  "common_selected": {
    "one": "Selecionado",
    "other": "Selecionados",
    "zero": "Nenhum selecionado"
  },
  "common_show_all": "Ver tudo",
  "common_show_less": "Ver menos",
  "common_tickets": "Ingressos",
  "common_unexpected_error": "Ocorreu um erro inesperado.",
  "common_wallet": "Carteira",
  "complement": "Complemento",
  "complement_page_dados": "Complemento",
  "complete_seu_cadastro": "Complete seu cadastro",
  "concluir": "Finalizar",
  "confirm": "Confirmar",
  "confirm_action": "Confirmar ação",
  "confirm_exit_dialog_page": "Você tem certeza que deseja sair?",
  "confirm_your": "Confirme seu e-mail para prosseguir:",
  "contact_country": "País",
  "contact_information": "Informações de contato",
  "contato_formLabels_brasileiro": "Sou brasileiro",
  "contato_formLabels_estrangeiro": "I am not Brazilian",
  "conversion_rate": "Conversão",
  "convidados_reenviar_convite": "Reenviar",
  "convite_reenviado_sucesso": "Convite reenviado com sucesso",
  "copiado": "Copiado",
  "copy_key_code": "Copiar chave",
  "country": "País",
  "coupon_apply_coupon": "Aplicar",
  "coupon_code_copied": "Código do cupom copiado",
  "coupon_required": "Uso de cupom obrigatório para o lote {}",
  "coupon_updated": "As informações do cupom foram alteradas",
  "coupons_1xpurchase": "1x por compra",
  "coupons_1xuser": "1x por usuário",
  "coupons_activation": "Ativar",
  "coupons_active": "Ativos",
  "coupons_add": "Adicionar",
  "coupons_add_coupon": "Adicionar cupom",
  "coupons_all": "Todos os cupons",
  "coupons_apply": "Aplicar em",
  "coupons_apply_all": "Aplicável em todos os lotes",
  "coupons_apply_choose": "Selecione os lotes",
  "coupons_apply_cpf": "Aplicar apenas uma vez por usuário/CPF (requer Login)",
  "coupons_apply_purchase": "Aplicar em apenas um ingresso por compra",
  "coupons_counter": "Quantidade de usos",
  "coupons_counter_of": "de",
  "coupons_deactivation": "Desativar",
  "coupons_delete": "Excluir cupom",
  "coupons_discount": "Desconto percentual (%)",
  "coupons_discount_fixed": "Desconto fixo",
  "coupons_manager_page_title": "Cupons",
  "coupons_name": "Nome do cupom",
  "coupons_name_select": "Cupom com nome",
  "coupons_name_shuffle": "Nome aleatório",
  "coupons_quantity": "Quantidade máxima de usos",
  "coupons_search": "Procurar cupons",
  "coupons_total": "Valor do desconto",
  "cpf": "CPF",
  "cpfId": "CPF",
  "cpf_id": "CPF",
  "credit_card": "Cartão de crédito",
  "credit_card_number": "Número do cartão",
  "criar_evento_codigo_disponivel": "URL disponível",
  "criar_evento_codigo_indisponivel": "URL indisponível",
  "criar_evento_compartilhar_evento": "Compartilhar evento",
  "criar_evento_contrato_aceitar": "Aceitar",
  "criar_evento_contrato_recusar": "Recusar",
  "criar_evento_contrato_title": "Vamos dar uma lida \nno contrato?",
  "criar_evento_copiar_lotes": "Copiar lotes",
  "criar_evento_criar_lotes": "Criar lotes",
  "criar_evento_criar_sessoes": "Criar sessões",
  "criar_evento_gerenciar_evento": "Gerenciar evento",
  "criar_evento_pergunta_pos_criacao": "O que você deseja fazer agora?",
  "criar_evento_pos_criacao_title": "Pronto!\nSeu {} foi criado!",
  "criar_evento_retomar_criacao": "Você já estava criando um evento antes, deseja continuar?",
  "criar_evento_retomar_criacao_title": "Retomar criação de evento:",
  "crud_edit_success": "Dados atualizados com sucesso",
  "cupom_formLabels_ativo": "Status",
  "cupom_formLabels_embaixador": "Promoter",
  "cupom_formLabels_extraOptions": "Opções avançadas",
  "cupom_formLabels_limitarUmaCompraPorUsuario": "Limitar a uma compra por usuário",
  "cupom_formLabels_limite": "Quantidade de cupons",
  "cupom_formLabels_lotes": "Lotes aplicáveis",
  "cupom_formLabels_nome": "Nome do cupom",
  "cupom_formLabels_valorDesconto": "Desconto",
  "cvv": "CVV",
  "dataI": "{data} à {dataFim} - {startTime}h",
  "date": "02 de Julho de 2022",
  "dateFormat": "dd MMMM yyyy",
  "date_of_birth": "Data de nascimento",
  "date_page_ticket": "Data",
  "detalhe_evento_informacoes_evento_title": "Informações do evento",
  "detalhe_evento_politicas_title": "Políticas do evento",
  "dinsintMonthDuration": "{diaInicio} à {diaFim} de {mesInicio} de {anoInicio} - {startTime}h",
  "discount_payment": "Desconto",
  "dontHaveAnAccount": "Ainda não tem conta?",
  "download_ticket_image": "Salvar imagem do ingresso",
  "edit": "Editar",
  "edit_info_date_beginning": "Data de início",
  "edit_info_date_end": "Data de término",
  "edit_info_description": "Descrição do evento",
  "edit_info_dimension": "Dimenssão recomendada",
  "edit_info_link": "URL do evento",
  "edit_info_picture": "Foto de capa",
  "edit_info_private": "Privado/Rascunho",
  "edit_info_public": "Público",
  "edit_profile": "Editar perfil",
  "email_ingresso": "E-mail",
  "email_page_dados": "E-mail",
  "email_payment": "E-mail",
  "email_register": "E-mail registrado",
  "email_ticket": "E-mail",
  "enter_promo_code": "Aplicar cupom",
  "entity_cupom": {
    "one": "Cupom",
    "other": "Cupons"
  },
  "entity_lote": {
    "one": "Lote",
    "other": "Lotes"
  },
  "error_event_not_found": "Evento não encontrado",
  "eventDateWithEndTime": "{day} de {month} de {year} de {startTime} às {endTime}h",
  "eventDateWithEndTimeAndLineBreak": "{day} de {month} de {year}\nde {startTime} às {endTime}h",
  "eventDateWithoutEndTime": "{date} - {startTime}h",
  "event_category_ALTERNATIVO": "🎶 Alternativo",
  "event_category_ANIVERSARIO": "🎉 Aniversário",
  "event_category_BRASILIDADE": "🇧🇷 Brasilidade",
  "event_category_DISCO": "🕺 Disco",
  "event_category_ELETRONICO": "🔊 Eletrônico",
  "event_category_FUNK": "🔥 Funk",
  "event_category_HALLOWEEN": "🎃 Halloween",
  "event_category_HOUSE": "🎧 House",
  "event_category_OUTRO": "Outro",
  "event_category_PALESTRA": "🎙️ Palestra",
  "event_category_POOL_PARTY": "💦 Pool Party",
  "event_category_POP": "🎤 Pop",
  "event_category_PRIVATIVO": "🔒 Privativo",
  "event_category_REVEILLON": "✨ Réveillon",
  "event_category_SAMBA": "🥁 Samba",
  "event_category_SERTANEJO": "🪗 Sertanejo",
  "event_category_TEATRO": "🎭 Teatro",
  "event_category_TRIBAL": "🪭 Tribal",
  "event_category_FEIRAS_E_CONGRESSOS": "🎟 Feiras e Congressos",
  "event_end_date": "Data de término do evento",
  "event_end_time": "Data de término",
  "event_link_copied": "Link do evento copiado",
  "event_loading_your_event": "Carregando seu evento...",
  "event_locale": "Local do evento",
  "event_name": "Nome do evento",
  "event_no_events": "Sem eventos cadastrados",
  "event_page_access": "Acessos à página do evento",
  "event_start_date": "Data de início",
  "event_start_time": "Hora de início",
  "event_status": "Status do evento",
  "event_status_active": "Ativo",
  "event_status_button_back": "Voltar",
  "event_status_button_cancel": "Solicitar cancelamento",
  "event_status_button_revert": "Reverter\nevento",
  "event_status_canceled": "Cancelado",
  "event_status_manage_event_active": "O status do seu evento está ATIVO.",
  "event_status_manage_event_attention": "Atenção, não é possível excluir um evento.",
  "event_status_manage_event_cancelled": "O status do seu evento está CANCELADO.",
  "event_status_manage_event_deadline": "Após o prazo, o cancelamento é feito automaticamente e os usuários receberão um e-mail de aviso e reembolso.",
  "event_status_manage_event_revert": "O cancelamento pode ser revertido em até 1h.",
  "event_status_manage_event_tocancel": "Para cancelar o seu evento, é preciso clicar no botão 'Solicitar cancelamento' para suspender as vendas e aguardar o prazo de 1H.",
  "event_status_nRemainingMinutes": {
    "one": "1 minuto restante",
    "other": "{} minutos restantes",
    "zero": "Tempo limite para reverter o cancelamento excedido"
  },
  "evento_created": "Evento criado com sucesso",
  "evento_curtidas_label": "Curtidas",
  "evento_lotes_empty": "Nenhum lote disponível",
  "evento_politicas": "1 - A Produção do evento e a Guedder não se responsabilizam por ingressos adquiridos em pontos de venda não oficiais. O site (guedder.com) e o app (Guedder: Eventos, Festas), também acessado em navegador pelo link (app.guedder.com), são os únicos canais de venda da Guedder. \n\n2 - Compras com suspeitas de fraude serão canceladas e reembolsadas automaticamente. \n\n3 - O não comparecimento ao evento invalida seu ingresso e não permite o reembolso. \n\n4 - Você poderá utilizar a ferramenta de transferência de ingressos no app apenas uma vez por ingresso. \n\n5 - Não é possível cancelar apenas um ingresso, sendo necessário cancelar todo o pedido. Os ingressos podem ser cancelados até 7 dias após a compra, desde que a solicitação seja feita antes das 48 horas que antecedem o início do evento. Se você estiver dentro do prazo, envie uma solicitação por e-mail para contato@guedder.com.\n\nHorário de atendimento do SAC da Guedder: De 11h às 19h, todos os dias, pelos canais: contato@guedder.com, FAQ e WhatsApp 21 97720-9822. \n\nPrecisa de ajuda? Acesse guedder.com e clique em \"Contato\" ou nos envie uma mensagem direta no Instagram @guedder. Para maiores informações, consulte nossas Políticas de Privacidade e Termos de Serviço encontrados em Perfil.",
  "evento_updated": "Suas informações foram salvas.",
  "excluir_conta": "Excluir conta",
  "expiration_date": "Data de vencimento",
  "expiration_month": "Mês de vencimento",
  "expiration_year": "Ano de vencimento",
  "expired_code": "Código expirado",
  "faq_buying_answer": "Para comprar seu ingresso, siga os passos abaixo:",
  "faq_buying_answer_step1": "1 – Localize o evento que deseja participar na página principal, busca ou link disponibilizado pelo organizador.",
  "faq_buying_answer_step2": "2 – Leia a descrição do evento e os detalhes sobre local, data e hora. Se tiver tudo certo, clique em Ver Ingressos.",
  "faq_buying_answer_step3": "3 – Você pode comprar quantos ingressos o organizador do evento permitir por compra. Você também pode selecionar ingressos de lotes diferentes. Ao terminar, clique em Próximo.",
  "faq_buying_answer_step4": "4 – Insira os dados referentes aos ingressos previamente selecionados e selecione Próximo.",
  "faq_buying_answer_step5": "5 – Selecione a forma de pagamento (Cartão de Crédito, Pix ou Paypal) e insira seus dados referentes. Após finalizar o pagamento, seu ingresso estará disponível na aba Ingressos em alguns instantes.",
  "faq_buying_question": "COMO COMPRAR INGRESSOS NA GUEDDER?",
  "faq_cancellation_answer": "Os ingressos podem ser cancelados até 7 dias após a compra, desde que a solicitação seja feita antes das 48 horas que antecedem o início do evento.",
  "faq_cancellation_answer_step_1": "1 – Abrir o ingresso que deseja cancelar na aba Ingressos.",
  "faq_cancellation_answer_step_2": "2 – Clicar em Opções e selecionar Cancelar Ingressos.",
  "faq_cancellation_answer_step_3": "3 – Leia as regras e clique em Cancelar Compra. Aguarde seu e-mail de confirmação do cancelamento. O reembolso será feito em até 2 dias úteis.",
  "faq_cancellation_question": "COMO É REALIZADO O CANCELAMENTO?",
  "faq_cancellation_reminder_1": "Se você tiver dentro do prazo, você precisa:",
  "faq_cancellation_reminder_2": "Lembre-se: não cancelamos ingressos individualmente, é feito o cancelamento de toda a compra.",
  "faq_contact_answer": "Se você precisa de ajuda e não encontrou sua pergunta aqui, escreva para a gente em contato@guedder.com para que um de nossos especialistas possa te ajudar. Você será respondido em alguns instantes.",
  "faq_contact_question": "COMO ENTRAR EM CONTATO COM O APP?",
  "faq_contact_reminder": "Se precisar entrar em contato conosco, você poderá escrever para a gente em contato@guedder.com",
  "faq_coupom_answer": "Você pode utilizar códigos promocionais para ativar descontos em seus ingressos:",
  "faq_coupom_answer_step1": "Após selecionar o evento que deseja participar, você poderá encontrar na tela Ver Ingressos a opção Aplicar Cupom. Basta digitar o código que você recebeu e clicar em Aplicar.",
  "faq_coupom_answer_step2": "O valor total de seus ingressos será atualizado automaticamente.",
  "faq_coupom_question": "COMO UTILIZAR UM CUPOM COM CÓDIGO PROMOCIONAL?",
  "faq_create_event_answer": "Venha realizar o seu evento com a gente! Uma plataforma completa de gestão dentro do app. Você pode criar, editar e acompanhar todas as informações do seu evento pelo aplicativo no seu celular, além de contar com o suporte dos nossos especialistas. Tudo em tempo real e sem sair do aplicativo.",
  "faq_create_event_contact": "Entre em contato conosco para ser um Organizador em contato@guedder.com",
  "faq_create_event_question": "COMO CRIAR UM EVENTO NA GUEDDER?",
  "faq_group_1": "Comprando",
  "faq_group_2": "SOBRE MEU INGRESSO",
  "faq_group_3": "CANCELAMENTO",
  "faq_group_4": "MINHA CONTA",
  "faq_login_answer_1": "O Login no aplicativo da Guedder pode ser realizado via conta Google (Gmail), Apple ID ou mediante cadastro no aplicativo. Para isso, basta clicar no ícone desejado na tela de Login ao baixar o aplicativo ou ao sair de sua conta.",
  "faq_login_answer_2": "Para sair de sua conta, clique em Sair na aba Perfil.",
  "faq_login_question": "COMO REALIZAR LOGIN NA GUEDDER?",
  "faq_payment_installment_answer": "Você pode parcelar a sua compra em quantas parcelas o organizador do evento determinar.",
  "faq_payment_installment_question": "POSSO PARCELAR MINHA COMPRA?",
  "faq_payment_method_answer": "Você pode comprar seus ingressos para festas e eventos na Guedder e pagar com Cartão de Crédito, PIX ou sua conta PayPal. Para pagamentos por PIX, nós disponibilizamos o código PIX para que você realize a transferência na função Copia e Cola no aplicativo do seu banco.",
  "faq_payment_method_answer_step1": "Pagamentos via conta PayPal podem ser pagos com cartões de débito, crédito ou saldo da sua conta PayPal.",
  "faq_payment_method_question": "QUAIS SÃO AS FORMAS DE PAGAMENTO ACEITAS?",
  "faq_refund_answer": "Após a realização do cancelamento da compra ou eventual cancelamento do evento, você receberá um e-mail com a confirmação do cancelamento e informações para reembolso. Lembre-se de manter seus dados de contato sempre atualizados.",
  "faq_refund_question": "COMO É REALIZADO O REEMBOLSO?",
  "faq_ticket_not_showing": "POR QUE MEU INGRESSO AINDA NÃO APARECE?",
  "faq_ticket_not_showing_answer_step1": "Após a sua compra, seu ingresso poderá levar alguns minutos até estar disponível na aba Ingressos no aplicativo. Se ocorrer algum problema na transação, nós entraremos em contato com você. Mantenha seus dados sempre atualizados em seu Perfil.",
  "faq_ticket_not_showing_answer_step2": "Lembre-se que seus ingressos só serão exibidos no aplicativo se você estiver logado no mesmo perfil que realizou a compra. Para confirmar qual conta está logada, selecione a aba Perfil e clique em Editar Dados.",
  "faq_ticket_present_my_ticket_answer": "Você tem seus ingressos sempre com você no aplicativo da Guedder. Basta clicar na aba Ingressos e selecionar o evento que participará. Lembre-se que caso tenha comprado mais de um ingresso para o mesmo evento, todos os ingressos estarão disponíveis na mesma página um abaixo do outro.",
  "faq_ticket_present_my_ticket_question": "COMO APRESENTO MEU INGRESSO NO EVENTO?",
  "faq_ticket_transfer_answer": "Seu ingresso é nomeado no momento da compra e não pode ser renomeado.",
  "faq_ticket_transfer_question": "POSSO TRANSFERIR MEU INGRESSO PARA OUTRA PESSOA?",
  "favorites_no_favorites": "Sem eventos favoritos.",
  "favorites_title": "Favoritos",
  "fee": "Sobre sua taxa",
  "festivalSemHora": "{data} a {dataFim}",
  "field_cannot_be_empty": "Campo obrigatório",
  "field_invalid": "{} inválido",
  "footer_create_event": "Criar evento",
  "footer_criar_espetaculo": "Criar peça de teatro",
  "footer_criar_festa_evento": "Criar festa ou evento",
  "footer_exit": "Sair",
  "footer_favorites": "Favoritos",
  "footer_home": "Home",
  "footer_profile": "Perfil",
  "footer_tickets": "Carteira",
  "full_name": "Nome completo",
  "full_name_page_dados": "Nome completo",
  "full_name_payment": "Nome completo",
  "full_name_ticket": "Nome completo",
  "hide_details": "Ocultar detalhes",
  "home_eventos_em_destaque": "EVENTOS EM DESTAQUE",
  "home_eventos_em_destaque_empty": "Sem eventos em destaque no momento",
  "home_mais_eventos": "MAIS EVENTOS",
  "home_mais_eventos_empty": "Sem mais eventos no momento",
  "home_mais_vistos": "MAIS VISTOS",
  "home_mais_vistos_empty": "Sem eventos mais vistos no momento",
  "home_proximos_eventos": "PRÓXIMOS EVENTOS",
  "home_proximos_eventos_empty": "Sem eventos próximos no momento",
  "identidade_genero": "Identidade de gênero",
  "increase_payment": "Acréscimo",
  "info_pagamento_address": "Endereço",
  "info_pagamento_contact": "Contato",
  "info_pagamento_payment_method": "Selecione a forma de pagamento",
  "ingresso_ainda_nao_disponivel": "Seu ingresso não está disponível ",
  "ingresso_ainda_nao_disponivel_detail": "Seu pagamento ainda está sendo processado e em até 5 minutos estará disponível para uso",
  "ingresso_cancelar_ingresso_subject": "Sobre o cancelamento de ingressos do evento {}.",
  "ingresso_detalhe_transferir": "Transferir ingresso",
  "ingresso_enviado": "Ingresso transferido para",
  "ingresso_enviar_por_email": "Enviar por e-mail",
  "ingresso_numero_ingresso": "Código do ingresso",
  "ingresso_recebido": "Você recebeu um ingresso:",
  "inserir_cupom_label": "Inserir cupom",
  "installments_fee": "Taxa de parcelamento ({feeValue})",
  "installments_payment": "Parcelas",
  "installments_price": "Valor das parcelas",
  "invalid_email": "E-mail inválido",
  "invalid_promo_code": "Cupom inválido",
  "invitations_add": "Enviar convites",
  "invitations_deactivate": "Desativar",
  "invitations_display": "Exibir desativados",
  "invitations_manager_page_title": "Convites",
  "invitations_text": "Digite ou cole até 50 e-mails separados por vírgulas por vez...",
  "know_about_your_fee": "Saiba sobre sua taxa",
  "know_about_your_fee_page": "Entenda sua taxa",
  "label_total_tickets": "Qtd. de ingressos à venda",
  "last_sales": "Últimas vendas",
  "line_djs": "Line-up",
  "line_evento_label": "Line-up",
  "loading": "Carregando",
  "loading_events": "Carregando eventos...",
  "loading_favorites": "Buscando favoritos",
  "loading_tickets": "Carregando ingressos",
  "loginStatusCancelled": "Login cancelado pelo usuário",
  "loginStatusFailed": "Falha ao logar com Facebook",
  "login_apple": "Entrar com Apple ID",
  "login_confirm_password": "Confirmar senha",
  "login_enter": "Entrar",
  "login_facebook": "Entrar com Facebook",
  "login_forgot_password": "Esqueceu a senha?",
  "login_google": "Entrar com o Google",
  "login_name": "Nome",
  "login_name_password": "Senha",
  "login_password": "Senha",
  "login_password_same": "A nova senha deve ser diferente da atual",
  "login_password_unmatch": "Senhas não coincidem",
  "login_register": "Cadastrar",
  "manage_event": "Gerenciar evento",
  "manage_event_invitations_quantity": "Convites enviados",
  "manage_event_title": "Gerenciar evento",
  "manage_event_total_of_participants": "Total de participantes",
  "manage_menu_batches": "Lotes",
  "manage_menu_checkin": "Check-in",
  "manage_menu_coupons": "Cupons",
  "manage_menu_invitations": "Convites",
  "manage_menu_sales": "Vendas",
  "manage_menu_withdrawals": "Saques",
  "manage_sales_card_paid_sales": "Vendas pagas",
  "manage_sales_card_withdrawal_balance": "Saldo para repasse",
  "manage_sales_card_withdrawals": "Saques realizados",
  "metaPixel": "Pixel da Meta",
  "meus_ingressos_ver_eventos_button": "Ver eventos",
  "min_length": "Mínimo de {} caracteres",
  "minha_pagina_formLabels_emailContato": "E-mail de contato",
  "minha_pagina_formLabels_nomeFantasia": "Nome da página",
  "minha_pagina_formLabels_photoUrl": "Foto de perfil",
  "minha_pagina_formLabels_url": "URL da página",
  "minhas_compras_pedidos_search_label": "Buscar por evento ou código do pedido",
  "minhas_compras_produtos_comprar_mais": "Comprar mais",
  "minhas_vendas_no_data": "Você ainda não foi adicionado para promover as vendas de nenhum evento.",
  "minhas_vendas_page_title": "Minhas vendas",
  "more_info": "Saiba mais",
  "must_be_numeric": "Campo numérico",
  "nTickets": {
    "one": "1 ingresso",
    "other": "{} ingressos",
    "zero": "Sem ingressos"
  },
  "nVisitas": {
    "one": "1 visita",
    "other": "{} visitas",
    "zero": "Sem visitas"
  },
  "neighborhood_payment": "Bairro",
  "neighborhood_payment_profile": "Bairro",
  "next": "Próximo",
  "next_ingresso": "Próximo",
  "no": "Não",
  "no_data": "Não há informações no momento.",
  "no_events_yet": "Sem eventos ainda",
  "no_sales_yet": "Sem vendas ainda",
  "not_applicable_coupon": "O cupom aplicado não é válido para nenhum lote selecionado.",
  "not_found": "Não encontrado",
  "nova_senha": "Nova senha",
  "nova_versao_disponivel": "Uma nova versão está disponível!",
  "number": "Número",
  "number_of_installments": "Número de parcelas",
  "number_page_dados": "Número",
  "open_in_maps": "Abrir no Mapa",
  "options": "Opções",
  "orAccessWith": "ou acesse com",
  "order_number": "Código do ingresso",
  "pagina_vendedor_collab": "COLLAB",
  "pagina_vendedor_proximos_eventos": "PRÓXIMOS EVENTOS",
  "paid_sales": "Vendas pagas",
  "passport_number": "CPF",
  "password_updated": "Senha alterada com sucesso!",
  "payment_completed": "Compra realizada",
  "payment_information": "Dados de pagamento",
  "payment_information_ticket": "Informações de pagamento",
  "paypal": "PayPal",
  "perfil_alterar_foto": "Alterar",
  "perfil_editar_perfil": "Editar perfil",
  "perfil_versao": "Versão {}",
  "permissao_admin_socio": "Sócio",
  "permissao_created": "{} adicionado com sucesso",
  "permission": "Permissão",
  "permission_add_button": "Adicionar",
  "permission_added_people": "Pessoas adicionadas",
  "permission_manager": "Gerente",
  "permission_manager_page_title": "Permissões",
  "permission_permission": "Permissão",
  "picture_max_file_size": "A foto deve ter no máximo {}",
  "pix": "Pix",
  "pix_cpf_warning": "O {} estará ativo após o preenchimento do CPF. Caso não possua CPF, selecione outra forma de pagamento.",
  "pix_interval": "em até {} minutos",
  "produtos_adicionar_produto": "Adicionar produto",
  "produtos_evento_finalizado": "Evento finalizado",
  "produtos_quantidade_itens": {
    "many": "{} itens",
    "one": "{} item",
    "other": "{} itens",
    "zero": "Nenhum item"
  },
  "produzido_por": "Produzido por",
  "profile_delete_account": "Excluir conta",
  "profile_exit": "SAIR",
  "profile_help": "Ajuda",
  "profile_manage_events": "Gerenciar eventos",
  "profile_manage_producers": "Gerenciar produtores",
  "profile_privacy_policy": "Políticas de Privacidade",
  "profile_terms_of_service": "Termos de Serviço",
  "profile_update_data": "Editar perfil",
  "profile_update_photo": "Alterar",
  "profile_updated": "Dados atualizados com sucesso",
  "promo_code": "Cupom",
  "promo_code_already_used": "Cupom já utilizado",
  "promo_code_applied": "Cupom {} aplicado com sucesso!",
  "promo_code_error": "Erro ao aplicar cupom.",
  "proximos_eventos": "Todos os estados",
  "qr_code_error_msg": "Não foi possível recuperar o QR Code",
  "qr_code_scanner_digitar_codigo": "Digitar código",
  "qtdProdutosCarrinho": "{count, plural, =0{vazio} =1{1 item} other{{count} itens}}",
  "recarregar": "Recarregar",
  "refuse": "Recusar",
  "reload": "Recarregar",
  "remove_promo_code": "Remover cupom",
  "reportar_problema": "Reportar um problema",
  "required_field": "Campo obrigatório",
  "required_photo": "Foto obrigatória.",
  "reset_password": "Esqueci minha senha",
  "reset_password_send": "Enviar",
  "role_admin": "Administrador",
  "sales_beginning": "Início das vendas",
  "sales_cell": "Celular",
  "sales_coupon": "Cupom",
  "sales_date": "Data",
  "sales_end": "Término das vendas",
  "sales_manager_page_title": "Vendas",
  "sales_name": "Nome",
  "sales_paid": "Vendas pagas (com taxas)",
  "sales_pending": "Vendas pendentes",
  "sales_price": "Valor",
  "sales_quantity": "Qtd. de ingressos",
  "sales_tag_canceled": "Canceladas",
  "sales_tag_errors": "Erros",
  "sales_tag_new": "Novas",
  "sales_tag_paid": "Pagas",
  "sales_tag_pending": "Pendentes",
  "sales_tag_refunds": "Estornadas",
  "sales_title": "Vendas",
  "save": "Salvar",
  "screens_criar_cupom": "Criar cupom",
  "screens_help": "Ajuda",
  "screens_idioma": "Idioma do app",
  "screens_meus_eventos": "Meus eventos",
  "screens_minha_pagina": "Minha página",
  "screens_minhas_compras": "Carteira",
  "screens_minhas_vendas": "Minhas vendas",
  "screens_notificacoes": "Notificações",
  "screens_politicas": "Políticas de Privacidade",
  "screens_termo_de_servico": "Termos de Serviço",
  "screens_termos_politicas": "Termos e Políticas",
  "search_by": "Buscar por {}",
  "search_event": "Buscar evento",
  "search_for_events": "Buscar evento",
  "see_details": "Ver detalhes",
  "see_tickets": "Ver ingressos",
  "see_tickets_pix": "Ver ingressos",
  "seller_agreement": "Declaro que li e estou de acordo com as regras de venda na {}",
  "send_code_again": "Reenviar",
  "send_report_mail_button": "Exportar participantes",
  "senha_atual": "Senha atual",
  "share": "Compartilhar",
  "share_batch": "Compartilhar lote",
  "signUp": "Cadastre-se",
  "skip": "Pular",
  "sold_out": "Esgotado",
  "sold_tickets": "Ingressos vendidos",
  "soon": "Em breve",
  "state": "Estado",
  "state_page_dados": "Estado",
  "street": "Endereço",
  "street_page_dados": "Endereço",
  "subtotal_label": "Subtotal",
  "subtotal_payment": "Subtotal",
  "tax_info": "Saiba sobre sua taxa",
  "tax_know_more": "Saiba mais",
  "tax_understand": "Entenda sua Taxa",
  "taxa": "taxa",
  "terms_of_service": "Termos de Serviço",
  "text_about_fee": "Tornamos a taxa do seu ingresso algo muito mais importante. A Guedder vai destinar parte do valor da taxa do seu ingresso a ONGs de apoio à cominudade LGBTQIA+, projetos de combate à LGBTfobia no Brasil, e outros. Você pode acompanhar nossas doações e os projetos que estamos ajudando em nosso site Guedder.com ",
  "text_action": "Essa ação é irreversível.",
  "text_delete_account": "Ao confirmar a exclusão, você não terá mais acesso ao aplicativo, bem como seus ingressos e eventos favoritos. Você poderá se cadastrar novamente.",
  "text_of": "de",
  "text_pix": "Utilize o código abaixo para realizar o pagamento via Pix na função Copia e Cola.",
  "ticket": "Ingresso",
  "ticket_active": "Ativos",
  "ticket_available": "disponível(s)",
  "ticket_cancel_transfer": "Cancelar transferência",
  "ticket_code": "Código do ingresso",
  "ticket_confirm_transfer_to": "Transferir este ingresso para",
  "ticket_fee": "Taxa de serviço",
  "ticket_finished": "Encerrados",
  "ticket_info": "Informações do ingresso",
  "ticket_no_ticket_selected": "Nenhum ingresso selecionado",
  "ticket_no_tickets": "Sem ingressos ativos",
  "ticket_payment_pending": "Aguardando pagamento",
  "ticket_received": "Recebido",
  "ticket_received_from": "Você recebeu um ingresso de {}",
  "ticket_received_ticket": "Ingresso recebido",
  "ticket_received_tickets": "Ingressos recebidos",
  "ticket_tickets_sent": "Ingressos enviados",
  "ticket_title": "Meus ingressos",
  "ticket_transferred_ticket": "Ingresso transferido",
  "ticket_transferred_tickets": "Ingressos transferidos",
  "ticket_transferred_to": "Ingresso transferido para {portador}",
  "ticket_waiting_confirmation": "Aguardando confirmação de recebimento",
  "tickets_no_inactive_tickets": "Sem ingressos anteriores",
  "time": "Hora",
  "time_dialog_determinar_intervalo_checkin": "Selecione o intervalo de check-in do lote:",
  "total_price": "Valor total:",
  "total_price_ingresso": "Valor total da compra",
  "total_price_lotes": "Valor total",
  "total_price_next_page": "Total geral",
  "total_price_payment": "Total geral",
  "total_sales": "Vendas totais",
  "transfer_search_user": "Buscar usuário por e-mail",
  "transfer_select_another_user": "Selecionar outra pessoa",
  "transfer_ticket": "Transferir ingresso",
  "transfer_transfer_ticket": "Transferir ingresso",
  "transfer_transfer_to": "Transferir meu ingresso para",
  "transfer_unknown_user": "Usuário desconhecido",
  "trocar": "Trocar",
  "trocar_senha": "Alterar senha",
  "unavailable": "Indisponível",
  "valid_brazil_number": "Entre 10 e 11 dígitos",
  "valid_international_number": "Mínimo de 7 dígitos",
  "vendedor_home_filter_ativo": "Ativo",
  "vendedor_home_filter_encerrado": "Encerrado",
  "ver_todos": "Todos os eventos",
  "waiting_payment": "Aguardando pagamento",
  "withdrawal_manager_page_title": "Saques",
  "withdrawals_add": "Cadastre sua conta abaixo:",
  "withdrawals_cpf_cnpj": "CPF ou CNPJ do realizador do evento",
  "withdrawals_name": "Nome completo ou razão social",
  "withdrawals_pix_code": "Chave PIX",
  "withdrawals_pix_key": "Tipo de chave PIX",
  "withdrawals_save": "Salvar",
  "withdrawals_text": "O repasse do saldo de cada evento é realizado em até 3 dias após o encerramento do evento.",
  "withdrawals_title": "Saques",
  "yes": "Sim",
  "zip_code": "CEP",
  "zip_code_page_dados": "CEP"
}

